import React, { Component, useState, useEffect } from "react";
import { Field, getFormValues, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { LiveSearch, Textarea, Toggle } from "../Form";
import { renderFormInput } from "../../modules/formTools";
import { ButtonBrand, ButtonPrimary, ButtonPrimaryRed } from "../Button";
import { withRouter } from "react-router";
import {
  createGroupForProgramme,
  editGroupForProgramme,
  fetchHotelGroupsForProgrammes,
  removeGroupFromProgramme,
  setOverridesForProgramme,
} from "../../services/hotelGroupService/preferredProgrammesService";
import { LiveSearchSimple } from "../Form/LiveSearch/LiveSearchSimple";
import {
  agencyHasFeature,
  isAgency,
  isRolePlatformAdmin,
  isSuperAgent,
} from "../../modules/auth";
import MultiSelect from "../../ui/MultiSelect";
import { ValueContainerDisplayResult } from "../corporate/reports/MultiValueComponents";
import { fetchAgencies, fetchCompanies, removeHotelGroupDealPercentage } from "../../redux/actions";
import PreferredProgrammeCommercialDealModal from "./PreferredProgrammeCommercialDealModal";
import { AGENCY_PERMISSIONS } from "../../constants";
import { email, minLength, required } from "../../modules/validation";

const form = "preferred-programme-override-form";
const v = {
  email: required("Please enter a valid email address"),
};
let PreferredProgrammeOverrideForm = ({
                                        hotelGroup,
                                        handleSubmit,
                                        token,
                                        match,
                                        isCustomGroup,
                                        isSuperAgent,
                                        hasChildAgencies,
                                        fetchAgencies,
                                        fetchCompanies,
                                        isAgency,
                                        programme,
                                        isCorporate,
                                        isRolePlatformAdmin,
                                        removeHotelGroupDealPercentage,
                                        agencyHasCorporatePermission,
                                        type = 'Edit'
                                      }) => {
  const [accountManager, setAccountManager] = useState(null);
  const [agencies, setAgencies] = useState(null);
  const [companies, setCompanies] = useState(null);
  const [selectedAgency, setSelectedAgency] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [openDealModal, setOpenDealModal] = useState(false);
  let hasDeal = programme && hotelGroup && hotelGroup.deals ? hotelGroup.deals.find((deal) => {
    if(programme.agency ){
      return (deal.apply_to_agency_id ===  programme.agency.id)
    }
    if(programme.company) {
      return (deal.apply_to_company_id === programme.company.id)
    }
    return false;
  }) : false


  useEffect(() => {
    if (isSuperAgent || isRolePlatformAdmin) {
      fetchAgencies(token, 1, { visibleOnly: true }, true).then(response => {
        setAgencies(response.data.data);
      });
    }
    fetchCompanies(token, 1, { visibleOnly: true, corporate: true }, true).then(
      response => {
        setCompanies(response.data.data);
      },
    );
  }, []);

  const getAgencyOptions = () => {
    let options = [];
    if (agencies && agencies.length > 0) {
      agencies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(agency => {
          options.push({
            text: agency.name,
            value: agency.id,
            label: agency.name,
          });
        });
    }
    return options;
  };

  const getCompanyOptions = () => {
    let options = [];
    if (companies && companies.length > 0) {
      companies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(company => {
          options.push({
            text: company.name,
            value: company.id,
            label: company.name,
          });
        });
    }
    return options;
  };

  const handleAgencySelect = e => {
    setSelectedAgency(e);

    fetchCompanies(token, 1, { agency: e.value, corporate: true }, true).then(
      response => {
        setCompanies(response.data.data);
      },
    );
  };

  const handleCompanySelect = e => {
    setSelectedCompany(e);
  };

  let submit = values => {
    values.default_account_manager_id = accountManager
      ? accountManager.id
      : null;
    values.agency_id = selectedAgency ? selectedAgency.value : null;
    values.company_id = selectedCompany ? selectedCompany.value : null;
    if (isCustomGroup) {
      if (!hotelGroup) {
        createGroupForProgramme(token, values).then(r => {
          window.location.href = `${
            isCorporate ? "/corporate/" : "/admin/"
          }preferred-programmes/${r.programme}/hotel-group/${r.group.id}/edit`;
        });
      } else {
        editGroupForProgramme(token, hotelGroup.id, programme.id, values).then(
          r => {
            window.location.href = `${
              isCorporate ? "/corporate/" : "/admin/"
            }preferred-programmes`;
          },
        );
      }
    } else {
      setOverridesForProgramme(token, hotelGroup.id, programme.id, values).then(
        r => {
          window.location.href = `${
            isCorporate ? "/corporate/" : "/admin/"
          }preferred-programmes`;
        },
      );
    }
  };
  let removeFromGroup = () => {
    removeGroupFromProgramme(
      token,
      match.params.programme,
      match.params.id,
    ).then(() => {
      window.location.href = `${
        isCorporate ? "/corporate/" : "/admin/"
      }preferred-programmes`;
    });
  };
  return (
    <form onSubmit={handleSubmit(submit)}>
      {isCustomGroup ? (
        <div>
          <div className="row">
            <div className="col col-w-full"></div>
            {isCustomGroup ? (
              <div className={"col-w-full"}>
                <div className="col col-w-full">
                  <Field
                    name="custom_group_name"
                    label="Name"
                    component={renderFormInput}
                  />
                </div>
              </div>
            ) : null}

            {!hotelGroup &&
            ((isSuperAgent && hasChildAgencies) || isRolePlatformAdmin) ? (
              <div className="col col-w-1/2 py-2">
                <MultiSelect
                  name="agency"
                  label="Add this group to an Agency Preferred Programme"
                  options={getAgencyOptions()}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  wrapperClassName="mb-0"
                  onChange={e => handleAgencySelect(e)}
                  value={selectedAgency}
                  autoComplete={"off"}
                  style={{
                    searchBox: {
                      "border-radius": "0px",
                    },
                  }}
                />
              </div>
            ) : null}
            {agencyHasCorporatePermission && getCompanyOptions().length > 0 && !hotelGroup && (isAgency || isRolePlatformAdmin) ? (
              <div
                className={`col ${
                  isSuperAgent || isRolePlatformAdmin
                    ? "col-w-1/2"
                    : "col-w-full"
                } py-2`}
              >
                <MultiSelect
                  isClearable
                  name="agency"
                  label="Add this group to a Corporate Account Preferred Programme"
                  options={getCompanyOptions()}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  wrapperClassName="mb-0"
                  onChange={e => handleCompanySelect(e)}
                  value={selectedCompany}
                  autoComplete={"off"}
                  style={{
                    searchBox: {
                      "border-radius": "0px",
                    },
                  }}
                />
              </div>
            ) : null}

            {isCustomGroup ? (
              <div className="col col-w-full">
                <LiveSearch
                  formId={"preferred-programme-override-form"}
                  name="venues_query"
                  multi="venues"
                  label="Venues"
                  auth
                  minLength={3}
                  url={`${window.API}/venues/quick`}
                  getText={item => item.display_name}
                />
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="row">
        <div className="col col-w-1/3">
          <Field
            name="account_manager_name"
            label="Account Manager"
            component={renderFormInput}
          />
        </div>
        <div className="col col-w-1/3">
          <Field
            name="default_account_manager_telephone"
            label="Account Manager Telephone"
            component={renderFormInput}
          />
        </div>
        <div className="col col-w-1/3">
          <Field
            name="default_account_manager_email"
            label="Account Manager Email Address"
            component={renderFormInput}
            validate={[v.email, email]}
          />
        </div>
        <div className="col col-w-full">
          <Field
            label="Profile"
            name="description_override"
            component={Textarea}
            rows={6}
          />
        </div>
        <div className="col col-w-full">
          <Field
            label="Educational Rates"
            name="education_rates_override"
            component={Textarea}
            rows={6}
          />
        </div>
        <div className="col col-w-full">
          <Field
            label="Preferred Packages"
            name="preferred_packages_override"
            component={Textarea}
            rows={6}
          />
        </div>
        <div className="col col-w-full">
          <div className={"flex justify-between"}>
            {hotelGroup ? (
              <ButtonPrimaryRed
                type="button"
                onClick={() => {
                  if (
                    window.confirm(
                      "Remove this group from preferred programme?",
                    )
                  ) {
                    removeFromGroup(hotelGroup);
                  }
                }}
              >
                {isCustomGroup
                  ? "Delete Custom Group"
                  : "Remove From Preferred Programme"}
              </ButtonPrimaryRed>
            ) : null}
            <ButtonPrimary type="submit">Save</ButtonPrimary>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col col-w-full py-2">
          <hr className={"my-4"} />
          <div  className={`flex justify-end`}>
            {type ==='Create' || hasDeal || (programme && (programme.agency && !!programme.agency.can_manage_commercial_deals) == false) || (programme && (programme.company && !!programme.company.can_manage_commercial_deals) == false)? <div></div> :  <ButtonPrimary onClick={() => setOpenDealModal(true)}>Add Commission Rate</ButtonPrimary>}
          </div>
        </div>
      </div>

      {hasDeal && programme && ((programme.agency && !!programme.agency.can_manage_commercial_deals) || (programme.company && !!programme.company.can_manage_commercial_deals)) ?
        <div className="row">
          <div className="col col-w-full py-2">
            <hr className={"my-4"} />
            <div className={`bg-primary px-3 py-6 block font-bold text-white my-5`}>
              <div>
                <p className={'flex justify-between'} style={{fontSize: '20px'}}>
                  <strong><i className="far fa-handshake"></i> Commercial Deal Available</strong>

                  <strong>{hasDeal.default_event_commission_percentage}% commission</strong>
                </p>
              </div>
              <hr className={'mb-4'}/>
              <div className={'flex justify-between'}>
                <p>
                  A commercial deal for {hasDeal.default_event_commission_percentage}% commission between  {programme.agency
                  ? programme.agency.name
                  : programme.company
                    ? programme.company.name
                    : ""} and   {hotelGroup ? hotelGroup.name : ""} may apply to this booking
                  {hasDeal.document_file ? (
                    <span className="font-bold text-xl block">
                    <span
                      onClick={() =>
                       null
                      }
                      role="button"
                      tabIndex="0"
                      className="text-base underline ml-2"
                    >
                  Download details of this deal
                </span>
              </span>
                  ) : null}
                </p>
                <div className={"flex justify-between"}>

                </div>
              </div>
            </div>
            <div
              className={`flex justify-end`}
            >

                <ButtonPrimaryRed onClick={() => removeHotelGroupDealPercentage(hotelGroup.id, programme.id, token)}>
                    Delete Commission Rate
                </ButtonPrimaryRed>
            </div>
          </div>
        </div>
      : <></>}
      {openDealModal ?
      <PreferredProgrammeCommercialDealModal  onClose={() => setOpenDealModal(false)} hotelGroup={hotelGroup} programme={programme}/>
      : null}
    </form>
  );
};

let PreferredProgrammeOverride = reduxForm({
  form: form,
  enableReinitialize: true,
})(PreferredProgrammeOverrideForm);

export default withRouter(
  connect(
    (state, props) => {
      let override =
        props?.hotelGroup?.overrides && props.programme
          ? props.hotelGroup.overrides.find(function(override) {
            return override.preferred_programme_id === props.programme.id;
          })
          : null;
      return {
        initialValues: {
          custom_group_name:
            props?.hotelGroup?.groupType?.code === "CHG" &&
            props?.hotelGroup?.name
              ? props.hotelGroup.name
              : "",
          venues:
            props?.hotelGroup && props?.hotelGroup?.venues?.length > 0
              ? props.hotelGroup.venues.map(v => v.id)
              : [],
          venues_text:
            props?.hotelGroup && props?.hotelGroup?.venues?.length > 0
              ? props.hotelGroup.venues.map(v => v.name)
              : [],
          account_manager_name:
            override && override?.account_manager
              ? override.account_manager
              : "",
          default_account_manager_telephone:
            override && override?.phone_number ? override.phone_number : "",
          default_account_manager_email:
            override && override?.email ? override.email : "",
          education_rates_override:
            override && override?.educational_rates
              ? override.educational_rates
              : "",
          preferred_packages_override:
            override && override?.preferred_packages
              ? override.preferred_packages
              : "",
          description_override:
            override && override?.description ? override.description : "",
        },
        isSuperAgent: isSuperAgent(state),
        isAgency: isAgency(state),
        hasChildAgencies:
          state.auth && state.auth.agency && state.auth.agency.child_agencies
            ? state.auth?.agency?.child_agencies.length > 0
            : false,
        isRolePlatformAdmin: isRolePlatformAdmin(state),
        agencyHasCorporatePermission: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_HAVE_CORPORATE_ACCOUNTS),
      };
    },
    { fetchAgencies, fetchCompanies, removeHotelGroupDealPercentage },
  )(PreferredProgrammeOverride),
);
